const DeckCards = class DeckCards {

    constructor(config) {
        this.deckCard = config.deckCard
    }

    init() {
        let deckCard = $(this.deckCard),
            scaleValue,
            speedValue,
            easeValue;

        if (window.innerWidth <= 800) {
            scaleValue = 1.1;
            speedValue = 0.2;
            easeValue  = 3;
        } else {
            scaleValue = 1.2;
            speedValue = 0.3;
            easeValue  = 1;
        }

        $(deckCard).on("mouseenter", function() {
            let $this = $(this);
            TweenMax.to($this, speedValue, {
                scale: scaleValue,
                force3D: "auto",
                ease: Back.easeOut.config(easeValue)
            });
        }).on("mouseleave", function() {
            let $this = $(this);
            TweenMax.to($this, speedValue, {
                scale: 1,
                force3D: "auto",
                ease: Back.easeOut.config(easeValue)
            });
        });
    }
};

export {DeckCards}


// WEBPACK FOOTER //
// ./static/js/components/DeckCards.js